import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { InputWrapper } from '../../../styles/EditDeleteStyles';
import { EmailRecipientsSelect } from './Shared/EmailRecipientsSelect';
import { RecipientsState } from './Shared/types';
import InputText from '../../../components/InputText';
import { BannerImageSelect } from './Shared/BannerImageSelect';
import { TextArea } from '../../../components/InputTextArea';
import { SelectStyled } from '../../../components/PageAction/styles';
import { FlexColumnStyled, FlexRowStyled } from '../../../styles/Flexbox';
import InputCheckbox from '../../../components/InputCheckbox/Index';
import { ButtonStyled } from '../../../components/Button/styles';
import InputDate from '../../../components/InputDate';
import { useBulkEmail } from '../../../hooks/useBulkEmail';
import { Sending } from './Shared/Sending';

type NewsletterProps = {
  onChange: (data: any) => void;
  continueEditing?: any;
  error?: any;
  loading: boolean;
};

type SectionProps = {
  index: number;
  section: any;
  handleChange: (data: any) => void;
  handleDelete: (data: any) => void;
};

function Section({
  index,
  section: { sectionTitle, format, bodyText, callToAction, sectionImageName, ctaText, ctaUrl },
  handleChange,
  handleDelete,
}: SectionProps): JSX.Element {
  const sectionTitleKey = `newsletter_section_title_${index}`;
  const bodyTextFormKey = `newsletter_body_text_${index}`;
  const ctaTextKey = `newsletter_cta_text_${index}`;
  const ctaUrlKey = `newsletter_cta_url_${index}`;

  return (
    <InputWrapper>
      <FlexRowStyled>
        <div
          style={{
            padding: '0px 0px 8px 0px',
            fontFamily:
              'Roboto, "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif',
            fontSize: '0.8125rem',
            fontWeight: 'bold',
            width: '170px',
          }}
        >
          Section {index + 1}
        </div>
        <div
          style={{
            padding: '0px 0px 8px 0px',
            fontFamily:
              'Roboto, "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif',
            fontSize: '0.8125rem',
          }}
        >
          Section Title
        </div>
      </FlexRowStyled>

      <InputText
        id={sectionTitleKey}
        keyName={sectionTitleKey}
        label=""
        placeholder="Please share the section title"
        inputValue={sectionTitle}
        handleHandle={(input) => {
          handleChange({ index, changedContent: { sectionTitle: input } });
        }}
        padding={false}
        theme="form"
        style={{ marginLeft: '170px' }}
      />

      <div
        style={{
          padding: '12px 0px 8px 170px',
          fontFamily:
            'Roboto, "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif',
          fontSize: '0.8125rem',
        }}
      >
        Section format
      </div>
      <SelectStyled
        style={{ marginLeft: '170px' }}
        onChange={({ currentTarget }: React.ChangeEvent<HTMLSelectElement>) => {
          handleChange({
            index,
            changedContent: { format: currentTarget.value as any },
          });
        }}
        value={format}
      >
        {[
          { value: 'text', label: 'Text' },
          { value: 'image', label: 'Image' },
          { value: 'text_image', label: 'Text + Image' },
        ].map(({ label, value }, i) => (
          <option value={value} key={i}>
            {label}
          </option>
        ))}
      </SelectStyled>
      {(format === 'text' || format === 'text_image') && (
        <>
          <div
            style={{
              padding: '12px 0px 8px 170px',
              fontFamily:
                'Roboto, "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif',
              fontSize: '0.8125rem',
            }}
          >
            Body Text
          </div>

          <TextArea
            id={bodyTextFormKey}
            keyName={bodyTextFormKey}
            label=""
            placeholder="Add your body text here"
            textValue={bodyText}
            handleHandle={(input) => {
              handleChange({ index, changedContent: { bodyText: input } });
            }}
          />
          {format === 'text_image' && (
            <>
              <div
                style={{
                  padding: '12px 0px 8px 170px',
                  fontFamily:
                    'Roboto, "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif',
                  fontSize: '0.8125rem',
                }}
              >
                Section Image
              </div>
              <BannerImageSelect
                noLabel
                fileName={sectionImageName}
                style={{ borderBottom: '0px' }}
                handleChange={(imageData: any) => {
                  handleChange({
                    index,
                    changedContent: { sectionImage: imageData, sectionImageName: imageData.name },
                  });
                }}
              />
            </>
          )}
          <FlexColumnStyled>
            <FlexRowStyled style={{ padding: '8px 0px 8px 170px' }}>
              <InputCheckbox
                label=""
                checkedValue={callToAction}
                handleChange={(input) => {
                  handleChange({ index, changedContent: { callToAction: input } });
                }}
              />
              <div
                style={{
                  padding: '8px 0px 8px 8px',
                  fontFamily:
                    'Roboto, "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif',
                  fontSize: '0.8125rem',
                }}
              >
                Call to Action
              </div>
            </FlexRowStyled>
            {callToAction && (
              <div
                style={{
                  padding: '8px 0px 8px 8px',
                  marginLeft: '170px',
                  marginBottom: '8px',
                  fontFamily:
                    'Roboto, "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif',
                  fontSize: '0.8125rem',
                  color: 'gray',
                }}
              >
                <InputText
                  id={ctaTextKey}
                  keyName={ctaTextKey}
                  label="CTA Button Text"
                  placeholder="Add text for the CTA button"
                  inputValue={ctaText}
                  handleHandle={(input) => {
                    handleChange({ index, changedContent: { ctaText: input } });
                  }}
                  padding={false}
                  theme="form"
                  style={{ width: '610px', marginBottom: '8px' }}
                />
                <InputText
                  id={ctaUrlKey}
                  keyName={ctaUrlKey}
                  label="CTA Button URL"
                  placeholder="Add URL for the CTA button (include https://)"
                  inputValue={ctaUrl}
                  handleHandle={(input) => {
                    handleChange({ index, changedContent: { ctaUrl: input } });
                  }}
                  padding={false}
                  theme="form"
                  style={{ width: '610px' }}
                />
              </div>
            )}
          </FlexColumnStyled>
        </>
      )}
      {format === 'image' && (
        <>
          <div
            style={{
              padding: '8px 0px 8px 170px',
              fontFamily:
                'Roboto, "Lucida Grande", "DejaVu Sans", "Bitstream Vera Sans", Verdana, Arial, sans-serif',
              fontSize: '0.8125rem',
            }}
          >
            Section Image
          </div>
          <BannerImageSelect
            noLabel
            fileName={sectionImageName}
            style={{ borderBottom: '0px' }}
            handleChange={(imageData: any) => {
              handleChange({
                index,
                changedContent: { sectionImage: imageData, sectionImageName: imageData.name },
              });
            }}
          />
        </>
      )}

      {index > 0 && (
        <div style={{ marginLeft: '170px', marginBottom: '8px' }}>
          <ButtonStyled
            style={{ backgroundColor: 'red', borderColor: 'darkred' }}
            onClick={() => handleDelete({ index })}
          >
            Delete this section
          </ButtonStyled>
        </div>
      )}
    </InputWrapper>
  );
}

export function Newsletter({
  onChange,
  continueEditing,
  error,
  loading,
}: NewsletterProps): JSX.Element {
  const { id } = useParams();
  const { getOneNewsletterEmail, newsletter } = useBulkEmail();
  const [recipients, setRecipients] = useState<RecipientsState>({ recipients: 'all' });
  const [subject, setSubject] = useState<string>();
  const subjectFormKey = 'newsletter_subject';
  const [openingMessage, setOpeningMessage] = useState<string>();
  const openingMessageFormKey = 'newsletter_opening_message';
  const [date, setDate] = useState<string>('');
  const dateKey = 'newsletter_date';
  const [bannerImage, setBannerImage] = useState<File>({} as File);
  const [bannerImageName, setBannerImageName] = useState<string>('');
  const [sections, setSections] = useState<any[]>([
    {
      sectionTitle: '',
      format: 'text',
      bodyText: '',
      callToAction: false,
      ctaText: '',
      ctaUrl: '',
      sectionImage: {},
      sectionImageName: '',
    },
  ]);

  const handleSectionChange = ({
    index,
    changedContent,
  }: {
    index: number;
    changedContent: any;
  }) => {
    setSections((prev) =>
      prev.map((content, i) => (i === index ? { ...content, ...changedContent } : content))
    );
  };

  const handleSectionDelete = ({ index }: { index: number }) => {
    setSections((prev) => prev.filter((_content, i) => i !== index));
  };

  React.useEffect(() => {
    if (id) {
      getOneNewsletterEmail(id);
    }
  }, []);

  React.useEffect(() => {
    if (newsletter) {
      const {
        recipients: emailTo,
        subject: newsletterSubject,
        opening_message,
        send_date,
        sections: newsletterSections,
        banner_image_name,
      } = newsletter as any;
      setRecipients({ recipients: emailTo });
      setSubject(newsletterSubject);
      setOpeningMessage(opening_message);
      setDate(send_date.split('T')[0]); // format to YYYY-MM-DD
      setSections(newsletterSections || []);
      setBannerImageName(banner_image_name);
    }
  }, [newsletter]);

  React.useEffect(() => {
    setBannerImageName(bannerImage?.name || '');
  }, [bannerImage]);

  React.useEffect(() => {
    onChange({
      recipients,
      subject,
      openingMessage,
      date,
      sections,
      ...(id || continueEditing ? { id: id || continueEditing } : {}),
      bannerImage,
      bannerImageName,
    });
  }, [
    recipients,
    subject,
    openingMessage,
    date,
    sections,
    bannerImage,
    bannerImageName,
    id,
    continueEditing,
    onChange,
  ]);

  if (loading) return <Sending />;

  return (
    <>
      <InputWrapper>
        <EmailRecipientsSelect
          initialValue={recipients}
          handleChange={(update) => {
            const updated = { ...recipients, ...update };
            setRecipients(updated);
          }}
        />
      </InputWrapper>

      <InputWrapper>
        <InputText
          id={subjectFormKey}
          keyName={subjectFormKey}
          label="Subject"
          error={error?.subject}
          placeholder="Email subject for newsletter"
          inputValue={subject ?? ''}
          handleHandle={setSubject}
          padding={false}
          theme="form"
        />
      </InputWrapper>
      <BannerImageSelect
        handleChange={(value: File) => setBannerImage(value)}
        fileName={bannerImageName}
        error={error?.bannerImageName}
      />

      <InputWrapper>
        <TextArea
          id={openingMessageFormKey}
          keyName={openingMessageFormKey}
          label="Open Text"
          error={error?.openingMessage}
          placeholder="Add your opening message here"
          textValue={openingMessage ?? ''}
          handleHandle={setOpeningMessage}
        />
      </InputWrapper>

      <InputWrapper>
        {sections.map((section, i) => (
          <Section
            key={`section-${i}`}
            index={i}
            section={section}
            handleChange={handleSectionChange}
            handleDelete={handleSectionDelete}
          />
        ))}
        <div style={{ marginLeft: '170px', marginTop: '8px' }}>
          <ButtonStyled
            onClick={() =>
              setSections([
                ...sections,
                {
                  sectionTitle: '',
                  format: 'text',
                  bodyText: '',
                  callToAction: false,
                  ctaText: '',
                  ctaUrl: '',
                  bannerImage: {},
                  bannerImageName: '',
                },
              ])
            }
          >
            Add more listing content
          </ButtonStyled>
        </div>
      </InputWrapper>
      <InputWrapper>
        <InputDate
          id={dateKey}
          keyName={dateKey}
          label={
            <>
              <div>Send-out Date</div>
              <div style={{ color: 'rgb(186, 33, 33)' }}>{error?.date}</div>
            </>
          }
          inputValue={date}
          handleChange={setDate}
        />
      </InputWrapper>
    </>
  );
}
